import { render, staticRenderFns } from "./OnlineStatisticsDetail.vue?vue&type=template&id=34a91239&scoped=true&"
import script from "./OnlineStatisticsDetail.vue?vue&type=script&lang=ts&"
export * from "./OnlineStatisticsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a91239",
  null
  
)

export default component.exports